'use client';
import { createContext, use, useEffect, useMemo, useState } from 'react';

const DeviceContext = createContext({
  deviceType: 'desktop',
  realDeviceType: 'desktop',
  isDesktop: false,
  isTablet: false,
  isMobile: false,
  isAdaptive: false,
});

export const DeviceScreenProvider = ({ children, initialType }) => {
  const [realType, setRealType] = useState(initialType);

  const isDesktop = realType === 'desktop';
  const isTablet = realType === 'tablet';
  const isMobile = realType === 'mobile';

  const isAdaptive = isTablet || isMobile;

  useEffect(() => {
    if (realType !== 'desktop') return undefined;

    const isTouchDevice = navigator.maxTouchPoints > 0 || 'ontouchstart' in window;

    if (isTouchDevice) {
      setRealType('tablet');
    }
    return undefined;
  }, [realType]);

  const contextValue = useMemo(
    () => ({ deviceType: initialType, isDesktop, isTablet, isMobile, isAdaptive }),
    [initialType, isDesktop, isTablet, isMobile, isAdaptive],
  );

  return <DeviceContext.Provider value={contextValue}>{children}</DeviceContext.Provider>;
};

export const useDeviceScreen = () => use(DeviceContext);
